const publicFun = function(Vue, options) {
	Vue.prototype.scrollToTop = function() {
		window.scrollTo({
		    top: 0,
		    left: 0,
		    behavior: 'smooth' // 平滑滚动
		 });
	},
	Vue.prototype.iframeBack = function() {
		history.go(-1)
	},
	Vue.prototype.openPage = function(url) {
		var hostName = window.location.protocol + '//' + window.location.host;
		if(url == '/'){
			window.location.href =  hostName
		}else{
			window.location.href =  hostName+'/'+url
		}
	},
	Vue.prototype.openPageBlank = function(url) {
		var hostName = window.location.protocol + '//' + window.location.host;
		if(url == '/'){
			window.open(hostName,'_blank')
		}else{
			window.open(url,'_blank')
		}
	},
	Vue.prototype.webIsMobile = function() {
		if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
			return true;
		} else {
			//电脑端
			return false;
		}
	}
}
export default publicFun; //
